// src/components/AnnualCalendar.jsx
import React from "react";
import calendarData from "../../data/anualCalender/anualCalenderData";

export default function AnnualCalendar() {
  return (
    <section id="annualcalendar" className="w-full bg-gray-50 py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-900 text-center mb-8">
          Annual Calendar – UPSC Civil Services Examination
        </h2>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto shadow-lg rounded-xl">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-indigo-900 text-white">
                <th className="p-4">Year</th>
                <th className="p-4">Stage</th>
                <th className="p-4">Notification Date</th>
                <th className="p-4">Last Date to Apply</th>
                <th className="p-4">Exam Date / Duration</th>
              </tr>
            </thead>
            <tbody>
              {calendarData.map((row, index) => (
                <tr
                  key={index}
                  className="border-b hover:bg-indigo-50 transition"
                >
                  <td className="p-4 font-semibold text-gray-800">
                    {row.year}
                  </td>
                  <td className="p-4 font-semibold text-red-700">
                    {row.stage}
                  </td>
                  <td className="p-4">{row.notification}</td>
                  <td className="p-4">{row.lastDate}</td>
                  <td className="p-4">{row.exam}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Card View */}
        <div className="md:hidden space-y-4">
          {calendarData.map((row, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg p-4 border-l-4 border-indigo-600"
            >
              <p className="font-bold text-gray-800">{row.year}</p>
              <p className="font-semibold text-red-700">{row.stage}</p>
              <p className="text-gray-800">
                <span className="font-medium">Notification:</span>{" "}
                {row.notification}
              </p>
              <p className="text-gray-800">
                <span className="font-medium">Last Date:</span> {row.lastDate}
              </p>
              <p className="text-gray-600 text-sm">
                <span className="font-medium">Exam:</span> {row.exam}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
